(function(){
  /* Nach-oben-Button */
  function initTop(){
    if(document.querySelector('.macp-top'))return;
    var b=document.createElement('button');
    b.type='button';b.className='macp-top';var TL=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0?'Back to top':'Nach oben';b.setAttribute('aria-label',TL);b.title=TL;
    b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
    document.body.appendChild(b);
    var tick=false;
    function upd(){b.classList.toggle('is-visible',window.scrollY>500);tick=false;}
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd);}},{passive:true});
    upd();
  }
  /* Bindestrich-Wörter in Überschriften nicht umbrechen (z. B. Mercedes-Benz) */
  var RX=/([^\s\-–]{1,12}-[^\s\-–]{1,14})/g;
  function noBreak(root){
    (root||document).querySelectorAll('h1,h2,h3').forEach(function(h){
      if(h.dataset.macpNw)return;h.dataset.macpNw='1';
      var w=document.createTreeWalker(h,NodeFilter.SHOW_TEXT,null),n,list=[];
      while(n=w.nextNode()){if(RX.test(n.nodeValue))list.push(n);RX.lastIndex=0;}
      list.forEach(function(t){
        if(t.parentNode.closest('.macp-nw'))return;
        var f=document.createDocumentFragment(),s=t.nodeValue,last=0,m;
        RX.lastIndex=0;
        while(m=RX.exec(s)){f.appendChild(document.createTextNode(s.slice(last,m.index)));var sp=document.createElement('span');sp.className='macp-nw';sp.textContent=m[1];f.appendChild(sp);last=m.index+m[1].length;}
        f.appendChild(document.createTextNode(s.slice(last)));t.parentNode.replaceChild(f,t);
      });
    });
  }
  function init(){initTop();noBreak();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
